import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { Heading, Stack, useColorModeValue } from "@chakra-ui/react";
import { AuthContext } from "../../Context/AuthContextProvider";
import "./Login.css";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import ForgotPassword from "./ForgotPassword";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import UseAnimations from "react-useanimations";
import instagram from "react-useanimations/lib/instagram";
import facebook from "react-useanimations/lib/facebook";
import linkedin from "react-useanimations/lib/linkedin";
import TextField from "@mui/material/TextField";
import { useMediaQuery } from "react-responsive";
import LoginWithGoogle from "./Google/LoginWithGoogle";

const initData = {
  email: "",
  password: "",
};

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [data, setData] = useState(initData);
  const { loginme, isAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const isMobile = useMediaQuery({
    query: "(max-width: 1024px)",
  });

  const handleForgotPassword = () => {
    setForgotPassword(!forgotPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await loginme(data);
      setIsLoading(false);
      document.getElementById("f").reset();
    } catch (error) {
      alert(`Error: ${error} `);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isAuth) {
      navigate("/dashboard/profile");
    }
  }, [isAuth]);

  return (
    <Box className="Login-Page pattern-bg2">
      <div className="login-flex-box">
        <Stack
          spacing={4}
          w={"full"}
          maxW={"xl"}
          bg={useColorModeValue("transparent", "gray.700")}
          rounded={"xl"}
          borderRadius="none"
          className="login-stack-box"
        >
          {forgotPassword ? (
            <Box className="login-box">
              <Box
                sx={{
                  marginRight: "auto",
                  width: "100%",
                  textAlign: "left",
                  justifyContent: "start",
                }}
              >
                <Button
                  onClick={handleForgotPassword}
                  startIcon={<ArrowBackOutlinedIcon />}
                  sx={{
                    color: "black",
                    padding: "8px 16px",
                    "&:hover": {
                      background: "#ede7d4 ",
                    },
                  }}
                >
                  Back To Login
                </Button>
              </Box>
              <ForgotPassword />
            </Box>
          ) : (
            <div className="login-box  ">
              <div className="flex flex-row justify-center login-title">
                <Heading
                  as="h1"
                  fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                  textAlign="center"
                  fontWeight="bold"
                  className="main-title Login text-[#101c4c]"
                >
                  <span className="font-normal">Hello,</span> <br />
                  Welcome!
                </Heading>
              </div>
              <form
                onSubmit={handleSubmit}
                id="f"
                role="form"
                className="login-page-form w-100"
              >
                <TextField
                  size="small"
                  required
                  id="email"
                  label="📧 Email"
                  onChange={handleChange}
                  variant="outlined"
                  className="w-full !mb-[12px]"
                  type="email"
                  name="email"
                />
                <TextField
                  size="small"
                  required
                  id="password"
                  label="🔑 Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  className="w-full !mb-[12px]"
                  name="password"
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  className="mt-[px] "
                  onClick={handleForgotPassword}
                  sx={{
                    color: "black",
                    padding: "8px 16px",
                    "&:hover": {
                      background: "#ede7d4 ",
                    },
                    marginTop: "16px",
                  }}
                >
                  Forgot Password?
                </Button>
                {/* <FormControlLabel control={<Checkbox />} label="Remember Me" /> */}
                <Stack spacing={6} className="mt-[24px]">
                  <Button
                    type="submit"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      backgroundColor: "#D4AF37",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                    }}
                    disabled={isLoading}
                    className="join-btn custom-btn main-button"
                  >
                    <div className="flex justify-center">
                      {isLoading ? (
                        <ThreeDots
                          data-testid="three-dots-loading"
                          color="#64432f"
                          height={25}
                          width={40}
                          timeout={1000000}
                        />
                      ) : (
                        "LOGIN"
                      )}
                    </div>
                  </Button>
                </Stack>
              </form>

              <Box className="">
                <div className="divider">Or</div>
              </Box>
              <div data-testid="login-with-google">
                <LoginWithGoogle />
              </div>
              {isMobile ? (
                <p className="text-center mb-2">
                  Don&apos;t have an account?{" "}
                  <Link to="/signup" className="text-[#2153ac] ">
                    Sign up
                  </Link>
                </p>
              ) : (
                <p></p>
              )}

              <Box
                component="section"
                sx={{
                  p: 2,
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "40px",
                }}
              >
                <span>Follow Us:</span>

                <a
                  href="https://www.instagram.com/branddotgold"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <UseAnimations
                    animation={instagram}
                    size={28}
                    strokeColor="#101c4c"
                    className="bg-gold-dark-gradient rounded-[6px]"
                  />
                </a>

                <a
                  href="https://www.facebook.com/people/Branddot-Gold/pfbid02yFDgEAM3Wto4ErvvA6FnmbKJM1B7DExeAQ8snB6pjLBB6WnFwVbLY9LTCeKBjpgHl/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <UseAnimations
                    animation={facebook}
                    size={28}
                    strokeColor="#101c4c"
                    className="bg-gold-dark-gradient rounded-[6px]"
                  />
                </a>

                <a
                  href="https://www.linkedin.com/company/gold-domains/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <UseAnimations
                    animation={linkedin}
                    size={28}
                    strokeColor="#101c4c"
                    className="bg-gold-dark-gradient rounded-[6px]"
                  />
                </a>
              </Box>
            </div>
          )}
        </Stack>
      </div>
    </Box>
  );
}
